<template>
  <div class="home">
    <Navbar :is-active="3"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/inboxSugerences" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Buzón de sugerencias</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Registros</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de sugerencia"  v-model="id" @keyup="search"/>
          <input type="text" placeholder="Nombre"  v-model="Nombre" @keyup="search"/>
          <input type="text" placeholder="Apellido"  v-model="Apellido" @keyup="search"/>
           <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label>Fecha de Registro</label>
            <input type="date" v-model="created_at" @change="search"/>
          </div>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

        </div>
        <br />
        <div class="page__buttons">
          <ButtonExport
              :data="companies"
              :columns="columns"
              :sheet-name="'Datos Socio Comercial'"
              :file-name="'Reporte Socio Comercial'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Acciones</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="company of companies" :key="company.id">
              <p >{{ codeFormat(company.id) }}</p>
              <p>{{ company.user_name }}</p>
              <p>{{ company.user_lastname }}</p>
              <p>{{ dateFormat(company.created_at) }}</p>
              <p>{{ company.suggestion_description }}</p>
              <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+company.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+company.id)" class="dropdown-content" :id="'id-dropdown-content'+company.id">
                    <router-link :to="{ path: '/BuzonSugerenciaAdminDetalle', query: { id: company.id }}" class="dropdown-item">
                      <i class="far fa-eye " ></i> Ver Detalle
                    </router-link>
                  </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ButtonExport from '@/components/ButtonExport.vue'
import Dropdown from '@/components/Dropdown.vue'
import { conditionalFormatValue } from '@/utils/formats'
import { dateFormat } from '@/utils/formats'
import { codeFormat } from '@/utils/formats'
import Pagination from '@/components/Pagination.vue';
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';
import $ from 'jquery'
import Navbar from '@/components/NavBar'

export default {
  name: 'BuzonSugerencias',
  components: {
    ButtonExport,
    Dropdown,
    Pagination,
    OpenArrow,
    HiddenArrow,
    Navbar
  },
  data() {
    return {
      type: 'BuzonSugerencias',
      id: '',
      Nombre: '',
      Apellido: '',
      Descripcion: '',
      status: '',
      pagination: [],
      usuario: '',
      fecha: '',
      created_at: '',
      companies: [],
      empty: [],
      columns: [
        { label: 'Código de Sugerencia', field: 'suggestion_id_user' },
        { label: 'Nombre', field: 'user_name' },
        { label: 'Apellido', field: 'user_lastname' },
        { label: 'Fecha de registro', field: 'created_at' },
        { label: 'Descripcion Sugerencia', field: 'suggestion_description' },
      ]
    }
  },
  methods: {
    show(divID){
      if (!$("body").hasClass("cerrarModal")){
        $('#'+divID).fadeIn();
        setTimeout(function () {
          $("body").addClass("cerrarModal");
        }, 10);
      }
    },
    clean_filter(){
      this.id = '';
      this.Nombre = '';
      this.Apellido = '';
      this.created_at = '';
      this.getall();
    },
    dateFormat,
    codeFormat,
    search: function() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        let paramSearch = {
          code: self.id,
          user_name: self.Nombre,
          user_lastname: self.Apellido,
          created_at: self.created_at,
        }
        this.getall(1, paramSearch)
      }.bind(this), 500);
    },
    handleClickInParent: function(page) {
      this.getall(page)
    },
    conditionalFormatValue,
    handleClick() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    zeroFill(number, width) {
      width -= number.toString().length
      if (width > 0) {
        return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
        )
      }
      return number + ''
    },
    getDate() {
      let dias = [
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo'
      ]
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]

      let date = new Date()

      const fechaNum = date.getDate()
      const mes_name = date.getMonth()

      let day = date.getDay() === 0 ? 6 : date.getDay() - 1
      this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
    },
    changePage(url) {
      this.$router.push(url)
    },
    branchOffice() {
      this.$router.push('/branchoffice')
    },
    async getall(page = 1, paramSearch = {}) {
      await axios.get('general/suggestion',{
        params: {
          page: page,
          id: paramSearch.code,
          user_name: paramSearch.user_name,
          user_lastname: paramSearch.user_lastname,
          fecha: paramSearch.created_at,
        },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }}).then( res => {
        if (res.data.data.total > 0){
          this.companies = res.data.data.data
          this.pagination = res.data.data
          this.empty = false
        }else{
          this.companies = []
          this.pagination = {}
          this.empty = true
        }
      })
    },
    deleteCompany(company_id) {
      this.$swal({
        title: '¿Estas seguro de eliminar al socio comercial?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          let result = axios
              .delete('general/company/' + company_id)
              .then(res => {
                if (res.data.success) {
                  this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Se elimino correctamente',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  this.$router.go(0)
                } else {
                  this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un problema',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
        }
      })
    }
  },
  created() {
    if (localStorage.getItem("token")) {
      this.usuario = localStorage.getItem('usuario')
      this.getDate()
      this.getall()
    } else {
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped>
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: 0.3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail {
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;
}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__containt {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;
}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p {
  margin: 0;
  font-weight: 600;
}

.body__containt {
  height: fit-content;
  min-height: 87vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  margin-bottom: 25px;
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #000000;
}
.body__containt .page__buttons .button:nth-child(2) {
  background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(3) {
  background: #262626;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 6);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  text-align: center;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 6);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
  text-align: center;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/*------BODY------*/
.body__sidebar.open{
  display: none;
}
/* .body__containt .page__filters input:nth-child(1) {
width: 300px;
margin: 0;
margin-right: 10px;
} */

/*------BODY------*/

/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
}
</style>
